<template>
  <div :class="screenClass">
    <v-card style="display: contents">
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-row
              cols="12"
              xs="12"
              sm="12"
              md="12"
              justify="center"
              class="mt-5"
            >
              <v-col
                cols="12"
                md="12"
                align="center"
                style="font-size: 22px; color: #14223c; cursor: pointer"
              >
                <p @click="openRateDialog()">Terminal Stamp</p>
                
              </v-col>
            </v-row>
            <v-row justify="center" v-show="ShowRateList" >
              <v-col cols="12" md="10">
                <v-autocomplete
                  :items="RateList"
                  item-text="rateDetail"
                  item-value="rateCode"
                  label=" Select Rate"
                  v-model="SelectRate"
                  required
                  clearable
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align="center" class="mt-5">
                <v-btn
                  v-if="Status"
                  height="40"
                  width="200"
                  :disabled="SelectRate == null"
                  outlined
                  color="red"
                  @click="OpenCamera()"
                >
                  หยุด Scan QR บัตรจอดรถ
                </v-btn>
                <v-btn
                  v-else
                  height="40"
                  width="200"
                  outlined
                  :disabled="SelectRate == null"
                  color="indigo"
                  @click="OpenCamera()"
                >
                  เริ่ม Scan QR บัตรจอดรถ
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-card flat>
                  <v-card-text>
                    <v-row justify="center">
                      <div style="width: 800px; height: auto">
                        <qrcode-stream
                          v-if="Status && scanning"
                          :key="scannerKey"
                          :constraints="qrConstraints"
                          :track="drawScanBox"
                          @decode="onDecode"
                          @init="onInit"
                        />
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="RedemptionSuccessDialog" persistent width="800">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-progress-circular color="red" indeterminate size="32 ">
            <span style="font-size: 14px">{{ timerCount }}</span>
          </v-progress-circular>
        </v-card-title>
        <v-card-text>
          <div>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="12" align="center">
                <p
                  style="
                    text-align: center;
                    font-size: 30px;
                    color: green;
                    font-weight: bold;
                  "
                >
                  Redemption Success
                </p>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="12" align="center" class="white rounded-sm">
                <table
                  style="
                    border-collapse: collapse;
                    width: 100%;
                    font-size: 20px;
                  "
                >
                  <tr>
                    <td style="color: #14223c">Ticket No.</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TicketNoDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">DateTime</td>
                    <td style="text-align: right; color: #14223c">
                      {{ DateTimeDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">Time In</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TimeInDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">Duration</td>
                    <td style="text-align: right; color: #14223c">
                      {{ DurationDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">License</td>
                    <td style="text-align: right; color: #14223c">
                      {{ CarLicenseDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">Type</td>
                    <td style="text-align: right; color: #14223c">
                      {{ VehicleNameDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">RateDetail</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="color: #14223c"></td>
                    <td style="text-align: right; color: #de7302">
                      <div>
                        {{
                          $t("message.RateDetailLang") == "ENG"
                            ? RateDetailENGDisplay.split("\r\n")[0]
                            : RateDetailDisplay.split("\r\n")[0]
                        }}
                      </div>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td style="color: #14223c">Total</td>
                    <td
                      style="text-align: right; color: green; font-size: 20px"
                    >
                      {{ numberWithCommas(TotalDisplay) }}
                      <span style="color: black; font-size: 16px"> Baht</span>
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoginSetRateDialog" persistent width="350">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn
            style="margin-top: -10px; z-index: 1"
            @click="closeRateDialog()"
            icon
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="1"></v-col>
            <v-col cols="12" md="10">
              <v-text-field
                placeholder="Username"
                type="text"
                dense
                outlined
                v-model="UsernameRate"
                @keyup.enter="LoginSetRatePermission"
              />
              <v-text-field
                placeholder="Password"
                :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="ShowPassword ? 'text' : 'password'"
                @click:append="ShowPassword = !ShowPassword"
                outlined
                dense
                v-model="PasswordRate"
                @keyup.enter="LoginSetRatePermission"
              />
            </v-col>
            <v-col cols="12" md="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <v-btn
                height="40"
                width="200"
                color="primary"
                @click="LoginSetRatePermission()"
              >
                Login
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  name: "TerminalStamp",
  components: {
    QrcodeStream,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRCodeData: "",
      id: null,
      Status: false,
      response: "",
      RateList: [],
      ShowRateList: true,
      timerCount: 7,
      SelectRate: null,

      LogID: null,
      TerminalID: null,
      DatetimeIn: "",
      TicketNo: "",
      CarLicense: "",
      MemberType: null,
      CarType: null,
      TenantID: null,
      RateData: null,
      Remark: "",

      ResponseRedeem: [],
      TicketNoDisplay: "",
      DateTimeDisplay: "",
      TimeInDisplay: "",
      DurationDisplay: "",
      CarLicenseDisplay: "",
      VehicleNameDisplay: "",
      RateCodeStringDisplay: "",
      RateDetailDisplay: "",
      RateDetailENGDisplay: "",
      TotalDisplay: "",
      RedemptionSuccessDialog: false,

      LoginSetRateDialog: false,
      UsernameRate: "",
      PasswordRate: "",
      ShowPassword: false,

      qrConstraints: {
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      },
      scanning: false,
      decodeLock: false,
      scannerKey: 0,

      IdleTimer: null,
      IdleSeconds: 0,
      LimitTime: 20,

      projectID: localStorage.getItem("ProjectSiteID"),
    };
  },

  computed: {
    isGiantScreen() {
      const bp = this.$vuetify.breakpoint;
      return bp.width >= 800 && bp.height >= 1100;
    },
    screenClass() {
      return this.isGiantScreen ? "giant-mode" : "";
    },
  },

  mounted() {
    let self = this;
    self.GetDataRateCodeTerminalStamp();
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            if (this.timerCount == 0) {
              this.RedemptionSuccessDialog = false;
              this.scanning = true;
              this.decodeLock = false;
              this.ClearDataRedemptionDisplay();
            }
          }, 1000);
        }
      },
      immediate: true,
    },
  },

  methods: {
    startIdleTimer() {
      this.clearIdleTimer();
      this.IdleSeconds = 0;

      this.IdleTimer = setInterval(() => {
        this.IdleSeconds++;
        if (this.IdleSeconds >= this.LimitTime) {
          this.stopCameraByIdle();
        }
      }, 1000);
    },

    resetIdleTimer() {
      this.IdleSeconds = 0;
    },

    clearIdleTimer() {
      if (this.IdleTimer) {
        clearInterval(this.IdleTimer);
        this.IdleTimer = null;
      }
    },

    stopCameraByIdle() {
      this.clearIdleTimer();

      this.Status = false;
      this.scanning = false;
      this.decodeLock = false;

      Swal.fire({
        icon: "info",
        text: "ไม่มีการทำรายการเป็นระยะเวลานาน กล้องถูกปิดอัตโนมัติ",
        timer: 4000,
        showConfirmButton: false,
      });
    },

    drawScanBox(ctx, frame) {
      const { width, height } = frame;
      const size = Math.min(width, height) * 0.65;
      const x = (width - size) / 2;
      const y = (height - size) / 2;
      ctx.clearRect(0, 0, width, height);
      ctx.strokeStyle = "#00FF99";
      ctx.lineWidth = 4;
      ctx.strokeRect(x, y, size, size);
    },

    OpenCamera() {
      this.Status = !this.Status;
      if (this.Status) {
        this.startIdleTimer();
        this.scanning = false;
        this.$nextTick(() => {
          this.scannerKey++;
          this.decodeLock = false;
          this.scanning = true;
        });
      } else {
        this.clearIdleTimer();
        this.scanning = false;
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        this.Status = false;
        this.scanning = false;
        this.decodeLock = false;

        Swal.fire({
          icon: "error",
          title: "Camera Error",
          width: 600,
          text: "ไม่สามารถเปิดกล้องได้",
        });
      }
    },

    resumeScan() {
      this.resetIdleTimer();
      this.scanning = false;
      this.$nextTick(() => {
        this.scannerKey++;
        this.decodeLock = false;
        this.scanning = true;
      });
    },

    ShowRateListStatus() {
      let self = this;
      self.ShowRateList = !self.ShowRateList;
    },

    openRateDialog() {
      let self = this;
      self.UsernameRate = "";
      self.PasswordRate = "";
      self.LoginSetRateDialog = true;
    },

    closeRateDialog() {
      let self = this;
      self.UsernameRate = "";
      self.PasswordRate = "";
      self.LoginSetRateDialog = false;
    },

    LoginSetRatePermission() {
      let self = this;
      let temp = {
        username: self.UsernameRate,
        password: self.PasswordRate,
      };
      axios
        .post(`${self.url}Login/LoginSetRatePermission`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ShowRateListStatus();
            self.closeRateDialog();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    async onDecode(result) {
      if (this.decodeLock) return;
      this.resetIdleTimer();
      this.decodeLock = true;
      this.scanning = false;
      this.QRCodeData = result;
      await this.SearchParkingByQRCode(result);
    },

    GetDataRateCodeTerminalStamp() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        projectID: self.projectID
      };
      axios
        .post(`${self.url}Redemption/GetDataRateCodeTerminalStamp`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    async BindingDataResponseAfterScan() {
      let self = this;
      if (self.response != "" && self.response != undefined) {
        if (self.response.length > 0 && self.response[0].status != "Fail") {
          self.LogID = self.response[0].logId;
          self.TerminalID = self.response[0].terminalInId;
          self.DatetimeIn = self.response[0].entryDateTime;
          self.MemberType = self.response[0].memberTypeId;
          self.CarType = self.response[0].vehicleTypeId;
          self.TicketNo = self.response[0].ticketNo;
          self.DateTime = new Date(
            self.response[0].entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TenantID = parseInt(localStorage.getItem("TenantID"));
          self.CarLicense = self.response[0].plateNo;
          self.VehicleName = self.response[0].vehicleTypeName;
          self.RateCodeString = self.response[0].rateCode;
          self.RateDetail = self.response[0].rateDetailTH;
          self.RateDetailENG = self.response[0].rateDetailEN;
          self.Total = self.response[0].total;
          await self.RedeemData();
        } else {
          Swal.fire({
            icon: "warning",
            width: 900,
            text: self.response[0].message,
          });
        }
      }
    },

    async SearchParkingByQRCode(data) {
      let self = this;
      self.LoadingDialog = true;
      self.QRCodeData = data;
      let temp = {
        LogCarparkID: data,
        LostCard: false,
        projectID: self.projectID
      };
      await axios
        .post(`${self.url}Redemption/GetParkingDetailByQRCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            if (response.data.data.length > 0) {
              self.timerCount = 7;
              self.BindingDataResponseAfterScan();
            }
          } else {
            Swal.fire({
              icon: "warning",
              width: 900,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
          self.resumeScan();
        });
    },

    async RedeemData() {
      let self = this;
      if (
        self.LogID == "" ||
        self.TerminalID == null ||
        self.DatetimeIn == "" ||
        self.TicketNo == "" ||
        self.CarLicense == "" ||
        self.MemberType == null ||
        self.CarType == null ||
        self.TenantID == null ||
        self.SelectRate == null
      ) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง !",
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          LogCarparkID: self.LogID,
          TerminalID: self.TerminalID,
          DatetimeIn: self.DatetimeIn,
          RunningNumber: self.TicketNo,
          PlateNumber: self.CarLicense,
          MemberType: self.MemberType,
          CarType: self.CarType,
          TenantID: self.TenantID,
          RateCode: self.SelectRate,
          Remark: self.Remark,
          projectID: self.projectID
        };
        await axios
          .post(`${self.url}Redemption/RedeemParking`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.ResponseRedeem = response.data.data;
              self.BindingDataResponse();
            }
          })
          .catch(function (error) {
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

            Swal.fire({
              icon: "warning",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    ClearDataRedemptionDisplay() {
      let self = this;
      self.TicketNoDisplay = "";
      self.DateTimeDisplay = "";
      self.TimeInDisplay = "";
      self.DurationDisplay = "";
      self.CarLicenseDisplay = "";
      self.VehicleNameDisplay = "";
      self.RateCodeStringDisplay = "";
      self.RateDetailDisplay = "";
      self.RateDetailENGDisplay = "";
      self.TotalDisplay = "";
      self.LogID = null;
      self.TerminalID = null;
      self.DatetimeIn = "";
      self.TicketNo = "";
      self.CarLicense = "";
      self.MemberType = null;
      self.CarType = null;
      self.TenantID = null;
      self.RateData = null;
      self.Remark = "";
      self.scanning = true;
      self.decodeLock = false;
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    BindingDataResponse() {
      let self = this;
      if (self.ResponseRedeem != "" && self.ResponseRedeem != undefined) {
        if (self.ResponseRedeem.status != "Fail") {
          self.TicketNoDisplay = self.ResponseRedeem.ticketNo;
          self.DateTimeDisplay = new Date(
            self.ResponseRedeem.entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TimeInDisplay =
            self.ResponseRedeem.entryDateTime.split(" ").length > 0
              ? self.ResponseRedeem.entryDateTime.split(" ")[1]
              : "";
          self.DurationDisplay =
            self.ResponseRedeem.parkHH +
            " hrs " +
            self.ResponseRedeem.parkMM +
            " mins";
          self.CarLicenseDisplay = self.ResponseRedeem.plateNo;
          self.VehicleNameDisplay = self.ResponseRedeem.vehicleTypeName;
          self.RateCodeStringDisplay = self.ResponseRedeem.rateCode;
          self.RateDetailDisplay = self.ResponseRedeem.rateDetailTH;
          self.RateDetailENGDisplay = self.ResponseRedeem.rateDetailEN;
          self.TotalDisplay = self.ResponseRedeem.total;
          self.RedemptionSuccessDialog = true;
          this.resetIdleTimer();
        }
      }
    },
  },
};
</script>
<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.giant-mode {
  padding: 20px !important;
}

.giant-mode * {
  font-size: 26px !important;
}

.giant-mode p,
.giant-mode .title {
  font-size: 70px !important;
  font-weight: 700 !important;
  text-align: center !important;
}

.giant-mode .v-autocomplete .v-input__control {
  min-height: 95px !important;
}

.giant-mode .v-autocomplete .v-input__slot {
  height: 95px !important;
  padding: 10px 20px !important;
  font-size: 28px !important;
}

.giant-mode .v-autocomplete input {
  font-size: 30px !important;
}

.giant-mode .v-autocomplete .v-label {
  font-size: 24px !important;
}

.giant-mode .v-autocomplete .v-icon {
  font-size: 34px !important;
}

.giant-mode .v-menu__content {
  transform: scale(1.3) !important;
  transform-origin: top left !important;
}

.giant-mode .v-list-item__title {
  font-size: 28px !important;
  padding: 16px 0 !important;
}


.giant-mode .v-btn {
  height: 95px !important;
  width: 90% !important;
  font-size: 50px !important;
  font-weight: bold !important;
  border-width: 3px !important;
  margin-top: 20px;
}

.giant-mode .v-dialog .v-card {
  padding: 40px !important;
  border-radius: 20px !important;
}

.giant-mode .v-dialog p,
.giant-mode .v-dialog span,
.giant-mode .v-dialog td {
  font-size: 30px !important;
}

.giant-mode table {
  font-size: 30px !important;
}

.giant-mode table td {
  padding: 16px 0 !important;
}

.giant-mode .total-row {
  font-size: 38px !important;
  font-weight: bold !important;
  color: green !important;
}

.giant-mode .baht-text {
  font-size: 26px !important;
}

.giant-mode .v-progress-circular {
  transform: scale(1.9) !important;
}

</style>
